var _rect, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFrame1171275375(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#FEF7F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.9196 40.1016V43.4849C29.9196 46.3516 27.253 48.6683 23.9696 48.6683C20.6863 48.6683 18.0029 46.3516 18.0029 43.4849V40.1016C18.0029 42.9682 20.6696 45.0016 23.9696 45.0016C27.253 45.0016 29.9196 42.9516 29.9196 40.1016Z",
    stroke: "#EFAE78",
    strokeWidth: 2.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9167 35.5182C29.9167 36.3515 29.6833 37.1182 29.2833 37.7848C28.3 39.4015 26.2833 40.4182 23.95 40.4182C21.6167 40.4182 19.6 39.3848 18.6166 37.7848C18.2166 37.1182 17.9834 36.3515 17.9834 35.5182C17.9834 34.0849 18.65 32.8015 19.7167 31.8682C20.8 30.9182 22.2833 30.3516 23.9333 30.3516C25.5833 30.3516 27.0667 30.9349 28.15 31.8682C29.25 32.7849 29.9167 34.0849 29.9167 35.5182Z",
    stroke: "#EFAE78",
    strokeWidth: 2.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9196 35.5192V40.1026C29.9196 42.9692 27.253 45.0026 23.9696 45.0026C20.6863 45.0026 18.0029 42.9526 18.0029 40.1026V35.5192C18.0029 32.6526 20.6696 30.3359 23.9696 30.3359C25.6196 30.3359 27.103 30.9192 28.1863 31.8526C29.253 32.7859 29.9196 34.0859 29.9196 35.5192Z",
    stroke: "#EFAE78",
    strokeWidth: 2.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6667 30.2859V33.7193C48.6667 34.636 47.9334 35.3859 47 35.4192H43.7333C41.9333 35.4192 40.2834 34.1026 40.1334 32.3026C40.0334 31.2526 40.4333 30.2692 41.1333 29.5859C41.75 28.9526 42.6 28.5859 43.5333 28.5859H47C47.9334 28.6193 48.6667 29.3692 48.6667 30.2859Z",
    stroke: "#EFAE78",
    strokeWidth: 2.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.333 29.5026V26.1693C15.333 21.6359 18.0663 18.4693 22.3163 17.9359C22.7497 17.8693 23.1997 17.8359 23.6663 17.8359H38.6663C39.0997 17.8359 39.5163 17.8526 39.9163 17.9193C44.2163 18.4193 46.9997 21.6026 46.9997 26.1693V28.586H43.533C42.5996 28.586 41.7496 28.9526 41.133 29.5859C40.433 30.2693 40.033 31.2526 40.133 32.3026C40.283 34.1026 41.933 35.4193 43.733 35.4193H46.9997V37.8359C46.9997 42.8359 43.6663 46.1693 38.6663 46.1693H34.4997",
    stroke: "#EFAE78",
    strokeWidth: 2.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame1171275375);
export default __webpack_public_path__ + "static/media/Frame 1171275375.673c8e2cd6796505bda07a38c24e9ee8.svg";
export { ForwardRef as ReactComponent };